/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAxNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI4IiBjeT0iMTcuNjY2IiByPSI4IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA4IDE3LjY2NikiIGZpbGw9IiMwMDVFQTYiLz48Y2lyY2xlIGN4PSI4IiBjeT0iOC4zMzM5OCIgcj0iNy41IiB0cmFuc2Zvcm09InJvdGF0ZSg5MCA4IDguMzMzOTgpIiBzdHJva2U9IiMwMDVFQTYiLz48L3N2Zz4=";